import React, { useEffect, useContext, useState, useRef } from "react";
import classnames from "classnames";
import { Tabs, Tab, TabList, TabPanel } from "react-tabs";
import AMap from "../../../components/AMapComp";
import { useHistory } from "react-router-dom";
import { formatDistance } from "../common/js/rescueSdk";
import MapMarker from "./MapMarker";
import { Context, DEFAULT_SERVICE_CALL_NUMBER } from "../common/js/constant";
import { formatPhoneNumber } from "../common/js/util";
import useQueryIndexDataHook from "../common/hooks/useQueryIndexDataHook";
import useQueryOrderListHook from "../common/hooks/useQueryOrderListHook";
import useQueryDriverGPSInfoHook from "../common/hooks/useQueryDriverGPSInfoHook";
import styles from "./index.module.scss";
import useAMapHook from "../../../hooks/useAMapHook";

export default function Progress() {
  const { state } = useContext(Context);
  const history = useHistory();
  const [curSelectedTabIndex, setCurSelectedTabIndex] = useState(0);
  useQueryIndexDataHook();
  const { isPending: isOrderListPending, orderList } = useQueryOrderListHook();
  const [pageConfig, setPageConfig] = useState({
    mobile: DEFAULT_SERVICE_CALL_NUMBER,
    address: "",
  });
  const [curOrderTarget, setCurOrderTarget] = useState({
    orderNumber: "",
    rescueStatus: "0",
  });
  const { gpsInfo } = useQueryDriverGPSInfoHook({
    orderNumber: curOrderTarget?.orderNumber,
    queryState: Number(curOrderTarget?.rescueStatus || 0) >= 3 ? 1 : 0,
  });

  const mapWrapper = useRef(null);
  const { mapEntity, loaded } = useAMapHook({
    container: mapWrapper.current,
  });

  useEffect(() => {
    document.title = "救援进度";
  }, []);

  useEffect(() => {
    setPageConfig(state.baseConfig);
  }, [state.baseConfig]);

  useEffect(() => {
    if (curSelectedTabIndex < 0 || !orderList || !orderList.length) return;
    setCurOrderTarget(orderList[curSelectedTabIndex]);
  }, [curSelectedTabIndex, orderList]);

  // 选中 tab
  function onTabSelected(i) {
    setCurSelectedTabIndex(i);
  }

  const onTapToUploadImages = () => {
    history.push(
      `/rescue-new/picture?orderNumber=${curOrderTarget?.orderNumber || ""}`,
    );
  };

  return (
    <div className={styles["rescue-progress-container"]}>
      {/* 救援进度页 */}
      <div className={styles["amap-container"]}>
        {orderList && orderList.length > 0 && (
          <div
            className={styles["upload-img-entrance"]}
            onClick={onTapToUploadImages}
          >
            上传照片
          </div>
        )}
        <AMap loaded={loaded} mapEntity={mapEntity} mapWrapper={mapWrapper}>
          <MapMarker
            orderNumber={curOrderTarget?.orderNumber}
            gpsInfo={{
              lng: Number(gpsInfo.driverLng),
              lat: Number(gpsInfo.driverLat),
            }}
          />
        </AMap>
      </div>
      <div className={styles["rescue-content-container"]}>
        {!!pageConfig?.mobile && (
          <div className={styles["rescue-tips-wrapper"]}>
            <div className={styles["tips-row"]}>
              <div className={styles["tips-content"]}>
                <svg
                  className={styles["phone-icon"]}
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="32px"
                  height="32px"
                  viewBox="0 0 32 32"
                  version="1.1"
                >
                  <title>phoneIcon</title>
                  <g
                    id="phoneIcon"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g>
                      <rect
                        id="矩形"
                        fillRule="nonzero"
                        x="0"
                        y="0"
                        width="32"
                        height="32"
                      />
                      <path
                        d="M18.8291116,21.2544222 L19.5618638,20.7934784 C19.8491649,20.6176837 20.0843996,20.4868057 20.3215851,20.3794008 C21.9798802,19.6137337 23.4453318,20.1547638 25.3813056,22.4478662 C26.5787537,23.8659205 26.9335434,25.1238021 26.4707719,26.2449574 C26.1275291,27.0828865 25.4642164,27.6610356 24.2821905,28.3739616 C24.2050795,28.4208544 23.5243937,28.8232088 23.3508478,28.9306404 C20.6011882,30.6494925 14.297753,26.715675 9.76444358,19.9926417 C5.2195609,13.252037 4.04333479,6.06418787 6.82963854,4.31991327 L7.19602782,4.08552921 L7.5970841,3.82185047 C9.00474866,2.89796014 9.90714506,2.52879924 10.9773139,2.71239163 C12.0455319,2.89796014 12.9537545,3.69879684 13.7192755,5.15589288 C15.3390019,8.24005815 14.9822614,9.70302915 12.8978391,11.0312233 C12.7474397,11.1288811 12.2152288,11.4550747 12.1651133,11.4863188 C11.6560489,11.8066642 12.5199029,13.9532665 14.5310632,16.9358484 C16.5692189,19.9516238 18.2718561,21.6021128 18.8291116,21.2505233 L18.8291116,21.2544222 Z"
                        id="路径"
                        stroke="#0F1521"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </g>
                </svg>
                <span className={styles["tips-content-text"]}>
                  如需取消救援请拨打：{formatPhoneNumber(pageConfig.mobile)}
                </span>
              </div>
              <a
                href={`tel:${pageConfig.mobile}`}
                className={styles["phone-call-btn"]}
              >
                立即联系
              </a>
            </div>
          </div>
        )}
        {orderList && orderList.length ? (
          <Tabs
            className={styles["tabs-panel-container"]}
            selectedIndex={curSelectedTabIndex}
            onSelect={onTabSelected}
            selectedTabClassName={styles["current-selected-tab"]}
          >
            <TabList className={styles["order-tab-list"]}>
              {orderList.map((orderItem, index) => {
                return (
                  <Tab
                    key={orderItem.orderNumber}
                    className={styles["order-tab-item"]}
                  >
                    <div className={styles["tab-title"]}>
                      救援工单 {index + 1}
                    </div>
                    <div className={styles["tab-sub-title"]}>
                      {orderItem.plateNo}
                    </div>
                  </Tab>
                );
              })}
            </TabList>
            {orderList.map((orderItem) => {
              return (
                <TabPanel key={orderItem.orderNumber}>
                  <RescueOrderPanel
                    orderItem={orderItem}
                    rulesLink={"/rules"}
                  />
                </TabPanel>
              );
            })}
          </Tabs>
        ) : (
          <div className={styles["empty-order-list"]}>
            {isOrderListPending ? "正在加载..." : "暂无工单数据"}
          </div>
        )}
      </div>
    </div>
  );
}

function RescueOrderPanel({ orderItem, rulesLink }) {
  const {
    rescueStatus,
    driverName,
    driverPhone,
    estimatedRescueTime,
    estimatedRescueDistance,
    distance,
    rescueDistance,
    confirmingTime,
    confirmedTime,
    onRoadTime,
    arriveTime,
  } = orderItem;
  const formattedDistance = formatDistance(
    estimatedRescueDistance || distance || rescueDistance,
  );
  const estimatedArrivalText = formattedDistance || estimatedRescueTime;

  switch (Number(rescueStatus)) {
    case 1:
      return (
        <div className={styles["content-panel"]}>
          <div className={styles["rescue-order-content"]}>
            <div className={styles["order-confirmed"]}>
              <i className={styles["waiting-icon"]} />
              <div className={styles["tips-text"]}>
                已经安排专人负责您的救援请求，请保持电话畅通。
              </div>
            </div>
            <Footer rulesLink={rulesLink} />
          </div>
        </div>
      );
    case 2:
    case 3:
    case 4:
      return (
        <div className={styles["content-panel"]}>
          <div className={styles["rescue-order-content"]}>
            <div className={styles["order-steps-list"]}>
              <div
                className={classnames(`${styles["step-content"]}`, {
                  [styles["z-step-completed"]]: Number(rescueStatus) > 3,
                })}
              >
                <div className={styles["checkbox-field"]}>
                  <i className={styles["checkbox-icon"]} />
                </div>
                <div className={styles["content-field"]}>
                  <div className={styles["step-title"]}>
                    救援到达
                    {!!arriveTime && (
                      <span className={styles["step-time"]}>{arriveTime}</span>
                    )}
                  </div>
                  <div className={styles["step-desc"]}>
                    救援车已到达指定地点
                  </div>
                </div>
              </div>
              <div
                className={classnames(`${styles["step-content"]}`, {
                  [styles["z-step-completed"]]: Number(rescueStatus) > 2,
                })}
              >
                <div className={styles["checkbox-field"]}>
                  <i className={styles["checkbox-icon"]} />
                </div>
                <div className={styles["content-field"]}>
                  <div className={styles["step-title"]}>
                    救援车辆在途
                    {!!onRoadTime && (
                      <span className={styles["step-time"]}>{onRoadTime}</span>
                    )}
                  </div>
                  <div className={styles["step-desc"]}>
                    救援车辆已经出发，救援司机：{driverName}，电话：
                    <a
                      className={styles["phone-num"]}
                      href={`tel:${driverPhone}`}
                    >
                      {driverPhone}
                    </a>
                    ， 预计 {estimatedArrivalText} 到达救援现场
                  </div>
                </div>
              </div>
              <div
                className={classnames(`${styles["step-content"]}`, {
                  [styles["z-step-completed"]]: Number(rescueStatus) > 1,
                })}
              >
                <div className={styles["checkbox-field"]}>
                  <i className={styles["checkbox-icon"]} />
                </div>
                <div className={styles["content-field"]}>
                  <div className={styles["step-title"]}>
                    救援已确认
                    {!!confirmedTime && (
                      <span className={styles["step-time"]}>
                        {confirmedTime}
                      </span>
                    )}
                  </div>
                  <div className={styles["step-desc"]}>
                    正在安排救援车辆，请您到安全的地方耐心等待。
                  </div>
                </div>
              </div>
              <div
                className={classnames(`${styles["step-content"]}`, {
                  [styles["z-step-completed"]]: Number(rescueStatus) > 0,
                })}
              >
                <div className={styles["checkbox-field"]}>
                  <i className={styles["checkbox-icon"]} />
                </div>
                <div className={styles["content-field"]}>
                  <div className={styles["step-title"]}>
                    救援确认中
                    {!!confirmingTime && (
                      <span className={styles["step-time"]}>
                        {confirmingTime}
                      </span>
                    )}
                  </div>
                  <div className={styles["step-desc"]}>
                    已经安排专人负责您的救援请求，请保持电话畅通。
                  </div>
                </div>
              </div>
            </div>
            <Footer rulesLink={rulesLink} />
          </div>
        </div>
      );
    default:
      return (
        <div className={styles["content-panel"]}>
          <div className={styles["rescue-order-content"]}>
            暂无工单信息
            <Footer rulesLink={rulesLink} />
          </div>
        </div>
      );
  }
}

function Footer({ rulesLink }) {
  if (!rulesLink) return null;
  return (
    <div className={styles["guide-rules-wrapper"]}>
      您还可以查阅
      <a className={styles["view-guide-rules"]} href={rulesLink}>
        《道路救援服务细则》
      </a>
    </div>
  );
}
